export var _tableAmountInputTheme = {
  baseStyle: {
    field: {
      textAlign: 'end',
      padding: 'xs',
      textStyle: 'body3',
      transition: 'all 0.1s ease-in-out',
      '&[data-error], &[data-error]:hover': {
        border: 'input.error'
      }
    },
    errorMessage: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }
};
//# sourceMappingURL=_TableAmountInput.theme.js.map